import { PRA_LOGIN } from '@/core/constants'
import NotifySvc from '@/services/NotifySvc'

export default function (error) {
  if (error.response.status === 403) {
    window.setTimeout(() => window.location = PRA_LOGIN, 1000)
    NotifySvc.error('You must be logged in to do that.');
  } else if (error.response.status === 404) {
    NotifySvc.error('Page not found.');
  } else if (error.response.status === 422) {
    const reasons = error.response.data.reasons
    if (Object.keys(reasons).length > 0) {
      NotifySvc.error(`${Object.keys(reasons)[0]} ${Object.values(reasons)[0]}`)
    } else {
      NotifySvc.error(error.response.data.error || 'Something went wrong...')
    }
  } else if (error.response.status === 500) {
    NotifySvc.error(error.response.data.error || 'Something went wrong...')
  }
  return Promise.reject(error)
}
